import { ApiProvider, MessageProvider, ModalContextProvider } from 'react-easyrocket';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
import { Router } from 'src/router';
import { FullScreenContext, useInitFullScreen } from 'src/hooks/useFullScreen';
import { FreeSpinsContext, useIniFreeSpins } from 'src/hooks/useFreeSpins';
import { API_URL, CONTENT_URL, isDev } from 'src/api';
import 'react-tooltip/dist/react-tooltip.css';
import i18n from 'src/modules/locales/utils/i18nInit';
import { QueryBoundaries } from 'src/components/QueryBoundaries';
import { MODAL_MAP } from 'src/constants/modals';
import { DrawersProvider } from './modules/drawers';
import { SettingsProvider } from './modules/settings/provider';
import { PromoEventContext } from './context/usePromoEvent';
import { I18nextProvider } from 'react-i18next';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: false
    }
  }
});

export const App = () => {
  const { oldFreeSpins, saveFreeSpins, freeSpinsChanged, setFreeSpinsChanged } = useIniFreeSpins();

  const fullScreenContext = useInitFullScreen();

  return (
    <FullScreenContext.Provider value={fullScreenContext}>
      <DrawersProvider config={['top', 'left', 'gamesSearch', 'providersSearch']}>
        <MessageProvider>
          <FreeSpinsContext.Provider
            value={{ oldFreeSpins, saveFreeSpins, freeSpinsChanged, setFreeSpinsChanged }}>
            <QueryClientProvider client={queryClient}>
              <I18nextProvider i18n={i18n}>
                {isDev && <ReactQueryDevtools initialIsOpen={false} />}
                <QueryBoundaries>
                  <ApiProvider apiUrl={API_URL} contentUrl={CONTENT_URL}>
                    <PromoEventContext>
                      <ModalContextProvider modalMap={MODAL_MAP}>
                        <SettingsProvider>
                          <Router />
                        </SettingsProvider>
                      </ModalContextProvider>
                    </PromoEventContext>
                  </ApiProvider>
                </QueryBoundaries>
              </I18nextProvider>
            </QueryClientProvider>
          </FreeSpinsContext.Provider>
        </MessageProvider>
      </DrawersProvider>
    </FullScreenContext.Provider>
  );
};
